import { DollarSign, Gauge, List, Percent, Shield, Type, type LucideIcon } from 'lucide-react';
import { OUTPUT_TYPES, describeOutputConfig } from '../classification/ClassificationOptions';
import type { Classification, ClassificationOutputType } from '../classification/ClassificationService';

const GOVERNANCE_CATEGORY = 'Governance';

/**
 * The governance policies shown in the register and detail views, in list order:
 * governance-category classifications, excluding drafts (not enforced/classified yet). The
 * register and detail page MUST use this so their shared ordering stays in sync.
 */
export function listedGovernancePolicies(all: Classification[]): Classification[] {
    return all.filter((c) => c.category === GOVERNANCE_CATEGORY && c.status !== 'draft');
}

/** An icon hinting the policy's output type — what kind of verdict it produces. */
const OUTPUT_ICON: Record<ClassificationOutputType, LucideIcon> = {
    scale: Gauge,
    currency: DollarSign,
    percent: Percent,
    category: List,
    text: Type,
};

export function outputIcon(outputType: ClassificationOutputType): LucideIcon {
    return OUTPUT_ICON[outputType] ?? Shield;
}

/** Summarizes a policy's output type for display, e.g. "SCALE · 1–10". */
export function describeOutputBadge(policy: Classification): string {
    const meta = OUTPUT_TYPES.find((t) => t.value === policy.outputType);
    const badge = meta?.badge ?? policy.outputType.toUpperCase();
    const detail = describeOutputConfig(policy.outputType, policy.outputConfig);
    return detail ? `${badge} · ${detail}` : badge;
}
